/* The Bird Porch — free-shipping progress in the cart drawer and cart page */
(function () {
  var THRESHOLD = 5000; /* cents — free US shipping from $50 */
  var ID = 'bp-ship';
  var last = null, busy = false, pending = false, timer = null;

  function money(c) { return '$' + (c / 100).toFixed(2); }

  function build() {
    var el = document.createElement('div');
    el.id = ID;
    el.innerHTML = '<p class="bp-ship__text"></p>' +
      '<span class="bp-ship__track"><span class="bp-ship__fill"></span></span>';
    return el;
  }

  function render(total) {
    if (typeof total !== 'number') return;
    last = total;
    var host = document.querySelector('.cart-drawer__summary, .cart__summary, .cart-totals');
    if (!host) return;
    var el = document.getElementById(ID);
    if (!el || !host.contains(el)) {
      if (el && el.parentNode) el.parentNode.removeChild(el);
      el = build();
      host.insertBefore(el, host.firstChild);
    }
    var left = THRESHOLD - total;
    var pct = Math.max(0, Math.min(100, (total / THRESHOLD) * 100));
    var t = el.querySelector('.bp-ship__text');
    var f = el.querySelector('.bp-ship__fill');
    if (left > 0) {
      t.textContent = 'Add ' + money(left) + ' for free US shipping.';
      el.classList.remove('bp-ship--done');
    } else {
      t.textContent = 'Free US shipping — you’re there.';
      el.classList.add('bp-ship--done');
    }
    f.style.width = pct.toFixed(1) + '%';
  }

  function refresh() {
    if (busy) { pending = true; return; }
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(c.total_price); })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (pending) { pending = false; refresh(); }
      });
  }

  function schedule() {
    if (last !== null && !document.getElementById(ID)) render(last);
    clearTimeout(timer);
    timer = setTimeout(refresh, 80);
  }

  function start() {
    refresh();
    ['cart:update', 'cart:refresh', 'variant:update'].forEach(function (e) {
      document.addEventListener(e, schedule);
    });
    var obs = new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) {
        var t = m[i].target;
        if (t && t.closest && t.closest('#' + ID)) continue;
        schedule();
        return;
      }
    });
    var roots = document.querySelectorAll('#shopify-section-cart-drawer-section, #cart-form, main');
    for (var i = 0; i < roots.length; i++) {
      obs.observe(roots[i], { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else { start(); }
})();
